import { useEffect, useRef } from 'react';

import { EventJournalQueries } from '@entities/eventJournal/model/queries';
import { useNuqsQueryState } from '@shared/hooks';

export const useJournalSearchQueryState = ({ value }: { value: string }) => {
    const {
        state,
        setState,
        clearQueryValue: clearQuerySearch,
    } = useNuqsQueryState(EventJournalQueries.search);

    const prevTrimmedRef = useRef<string>('');

    useEffect(() => {
        const trimmed = (value ?? '').trim();
        const wasEmpty = prevTrimmedRef.current.length === 0;
        const isEmpty = trimmed.length === 0;

        if (!wasEmpty && isEmpty) {
            void clearQuerySearch();
        }

        prevTrimmedRef.current = trimmed;
    }, [value, clearQuerySearch]);

    return {
        state,
        setState,
    };
};
